// https://atlassian.design/components/primitives/responsive/breakpoints
export const breakpointValues = {
  xxs: 0,
  xs: 480,
  sm: 768,
  md: 1024,
  lg: 1440,
  xl: 1760
};
export const Breakpoint = {
  xxs: 'xxs',
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl'
};
export const allBreakpoints = Object.values(Breakpoint);